import { render, staticRenderFns } from "./consolidate.vue?vue&type=template&id=ed3bbd8e&scoped=true&"
import script from "./consolidate.vue?vue&type=script&lang=js&"
export * from "./consolidate.vue?vue&type=script&lang=js&"
import style0 from "./consolidate.vue?vue&type=style&index=0&id=ed3bbd8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3bbd8e",
  null
  
)

export default component.exports